export default [
	{
		tenantId: '3f5a9c8a-4a78-4723-a9bd-3f43b18fe5be',
		settings: {
			workflow: {
				companyProfile: {
					hideIndustryPicker: true,
					defaultIndustry: 'Venue',
				},
			},
		},
	},
	{
		tenantId: '76081da2-5fdd-47b0-8caf-2c337ea3bf9f',
		settings: {
			workflow: {
				companyProfile: {
					hideIndustryPicker: true,
					defaultIndustry: 'Venue',
				},
			},
		},
	},
];
